<template>
  <div>
    <el-row class="wenzi"> 作品管理 </el-row>
    <el-row>
      <el-tabs v-model="activeName" @tab-click="search" stretch>
        <el-tab-pane
          :name="item.value"
          v-for="item in applyTypeList"
          :key="item.value"
        >
          <span slot="label">
            <el-badge :value="item.num || 0" :max="99">
              {{ item.label }}
            </el-badge></span
          >
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row>
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline table-dci"
      >
        <el-form-item>
          <el-input
            v-model="formInline.searchValue"
            placeholder="输入作品名/称流水号/DCI登记号/著作权人进行查询"
            class="input-with-select-cc"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <el-row>
      <el-table
        :data="tableData"
        border
        class="table-dci"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column fixed prop="date" label="作品详情" width="600">
          <template slot-scope="scope">
            <div>流水号: {{ scope.row.dciWorkId }}</div>
            <div>
              {{ getLabelByValue(scope.row.workCategory, workCategoryType) }}
            </div>
            <div class="showName" @click="toDetail(scope.row)">
              {{ scope.row.workName }}
            </div>
            <div class="showApp">{{ scope.row.showApplyInfo }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="状态" width="220">
          <template slot-scope="scope">
            <div class="showStatus-cc">
              {{ getLabelByValue(scope.row.monitorPayStatus, statusList) }}
            </div>
            <div
              v-if="
                scope.row.lastMonitorDiffDay &&
                scope.row.monitorPayStatus != 'WORKING'
              "
              class="showStatus-cc"
            >
              距离上次检测
            </div>
            <div
              class="showStatus-time"
              v-if="
                scope.row.lastMonitorDiffDay &&
                scope.row.monitorPayStatus != 'WORKING'
              "
            >
              {{
                scope.row.lastMonitorDiffDay
                  ? scope.row.lastMonitorDiffDay + "天"
                  : ""
              }}
            </div>
            <div
              class="showStatus-time"
              v-if="scope.row.monitorPayStatus == 'WORKING'"
            >
              {{ formatHours(scope.row.lastMonitorDiffHour) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              v-if="scope.row.monitorPayStatus == 'PAIED'"
              @click="monitorFicate(scope.row)"
              >提交监测</el-button
            >
            <el-button
              type="primary"
              v-if="scope.row.monitorPayStatus == 'NO_PAY'"
              @click="monitorFicatesdaf(scope.row)"
              >监测支付</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-row class="table-dci pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>

    <el-dialog title="监测" :visible.sync="dialogVisible" width="50%">
      <el-input v-model="keyWord" placeholder="监测关键词（选填）"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleClick">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付提示" :visible.sync="dialogVisiblePay" width="50%">
      <div>
        <el-result
          icon="success"
          title="成功提示"
          subTitle="付款成功后该订单下的所有产品都将运入后台审核阶段，请持续关注列表状态（也可手动刷新）。"
        >
          <template slot="extra">
            <el-button
              @click="dialogVisibleClickpay"
              type="primary"
              size="medium"
              >返回</el-button
            >
          </template>
        </el-result>
      </div>
    </el-dialog>

    <!-- 支付弹窗 -->
    <PaymentDialog ref="paymentDialog" />
  </div>
</template>
<script>
import {
  workList,
  workDelete,
  payDciWork,
  createMonitorTask,
  createRecordScreen,
  statusCount,
  payMonitor,
  getPayResult,
  getRecordScreenHis
} from "@/api/user.js";
import { toNumber, openPaymentWindow } from "@/utils/index";
import { PAY_TYPE } from "@/utils/constants";
import PaymentDialog from "@/components/PaymentDialog.vue";

export default {
  name: "DCIRegistration",
  components: { PaymentDialog },
  mixins: [],
  props: {},
  data() {
    return {
      dialogVisiblePay: false,
      tableData: [
        // {
        //   totalAmount: '0.00',
        //   dciWorkId: '2025Z11L000000002',
        //   record_screen_pay_status: 'NO_PAY',
        //   workCategory: 'WORD',
        //   authorName: '诸葛亮',
        //   showApplyInfo: '我申请',
        //   monitor_pay_status: 'NO_PAY',
        //   workName: '出师表',
        //   showCode: '2025Z11L000000002',
        //   dciWorkStatus: 'NO_PAY',
        //   dciUserId: 'DUSANDBOX8250207000000697929',
        //   fileType: 'TEXT'
        // }
      ],
      workCategoryType: [
        {
          /**
           * 文字作品，支持文件类型 TEXT
           */
          value: "WORD",
          label: "文字作品",
        },
        {
          /**
           * 口述作品，支持文件类型 AUDIO
           */
          value: "ORAL",
          label: "口述作品",
        },
        {
          /**
           * 音乐作品，支持文件类型 AUDIO
           */
          value: "MUSIC",
          label: "音乐作品",
        },
        {
          /**
           * 戏剧作品，支持文件类型 TEXT
           */
          value: "DRAMA",
          label: "戏剧作品",
        },
        {
          /**
           * 曲艺作品，支持文件类型 TEXT
           */
          value: "QUYI",
          label: "曲艺作品",
        },
        {
          /**
           * 舞蹈作品，支持文件类型 VIDEO
           */
          value: "DANCE",
          label: "舞蹈作品",
        },
        {
          /**
           * 杂技作品，支持文件类型 VIDEO
           */
          value: "ACROBATICS",
          label: "杂技作品",
        },
        {
          /**
           * 美术作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: "ART",
          label: "美术作品",
        },
        {
          /**
           * 建筑作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: "ARCHITECTURE",
          label: "建筑作品",
        },
        {
          /**
           * 摄影作品，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: "PHOTOGRAPHY",
          label: "摄影作品",
        },
        {
          /**
           * 电影作品，支持文件类型 VIDEO
           */
          value: "MOVIE",
          label: "电影作品",
        },
        {
          /**
           * 类似摄制电影方法创作的作品，支持文件类型 VIDEO
           */
          value: "AUDIOVISUAL",
          label: "类似摄制电影方法创作的作品",
        },
        {
          /**
           * 工程设计图、产品设计图，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: "DESIGN",
          label: "工程设计图、产品设计图",
        },
        {
          /**
           * 示意图，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: "DIAGRAM",
          label: "示意图",
        },
        {
          /**
           * 模型，支持文件类型 IMAGE、PDF_IMAGE
           */
          value: "MODEL",
          label: "模型",
        },
      ],
      // 状态列表
      statusList: [
        { value: "WORKING", label: "监测中" },
        { value: "NO_PAY", label: "待支付" },
        { value: "PAYING", label: "支付中" },
        { value: "PAIED", label: "已支付" },
        { value: "DCI_PRE_REG_AUDITING", label: "申领审核中" },
        { value: "DCI_PRE_REG_FINISH", label: "申领成功" },
        { value: "DCI_PRE_REG_FAIL", label: "申领失败" },
        { value: "DCI_PRE_REG_CANCEL", label: "dci撤销" },
        {
          value: "DCI_PRE_REG_TOBE_CONFIRM",
          label: "申领待确认，账户余额不足",
        },
        {
          value: "MONITORING_IN_PROGRESS",
          label: "监测中",
        },
        {
          value: "INFRINGEMENT_DETECTED",
          label: "有侵权",
        },
        {
          value: "EVIDENCE_COLLECTION_DONE",
          label: "取证完成",
        },
        {
          value: "RIGHTS_PROTECTION_IN_PROGRESS",
          label: "维权中",
        },
      ],
      applyTypeList: [
        {
          value: "total",
          label: "全部",
        },
        {
          value: "finish",
          label: "DCI",
        },
        {
          value: "monitor",
          label: "监控中",
        },
        {
          value: "evidence",
          label: "可维权",
        },
      ],
      // 总数量
      total: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [], // 表格数据
      formInline: {
        searchValue: "",
        applyType: "",
      },
      dialogVisible: false,
      dialogVisibleID: "",
      keyWord: "",
      activeName: "total", // 选中的标签页
    };
  },
  created() {
    statusCount({
      dciWorkStatus: "",
      searchValue: this.formInline.searchValue,
      params: {
        beginTime: "",
        endTime: "",
        applyType: "",
        status: this.activeName,
      },
    }).then((res) => {
      res.data.forEach((item) => {
        this.applyTypeList.forEach((applyType, index) => {
          if (item.key === applyType.value) {
            this.applyTypeList[index].num = item.count;
          }
        });
      });
    });
    this.search();
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    toDetail(row) {
      const fullURL = window.location.href;
      const urlBeforeHash = fullURL.split("#")[0];
      let url =
        urlBeforeHash +
        `#/InfoLock?dciWorkId=${row.dciWorkId}&dciContentId=${row.dciContentId}&monitorPayStatus=${row.monitorPayStatus}`;
      // 在新窗口中打开
      window.open(url, "_blank");
    },
    getLabelByValue(value, works) {
      const found = works.find((work) => work.value === value);
      return found ? found.label : value;
    },
    // 点击支付
    async pay(row) {
      const res = await payDciWork([row.dciWorkId], {
        phone: "17775134263",
        smsCode: "666",
      });
      console.log(res, "res");
      if (res.code == 200) {
        // 打开一个空白的新窗口
        const newWindow = window.open("", "_blank", "width=600,height=400");
        newWindow.document.write(res.msg);
      }
    },
    // 查询列表
    async search() {
      const res = await workList(
        {
          dciWorkStatus: "",
          searchValue: this.formInline.searchValue,
          params: {
            beginTime: "",
            endTime: "",
            applyType: "",
            status: this.activeName,
          },
        },
        {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          tableName: undefined,
          tableComment: undefined,
          isAsc: "desc",
          orderByColumn: "createTime",
        }
      );
      console.log(res, "res");
      if (res.code == 200) {
        this.tableData = res.rows;
        // // 添加测试数据
        // this.tableData = [
        //   ...res.rows,
        //   {
        //     totalAmount: '0.00',
        //     dciWorkId: '2025Z11L000000002',
        //     record_screen_pay_status: 'NO_PAY',
        //     workCategory: 'WORD',
        //     authorName: '诸葛亮',
        //     showApplyInfo: '我申请',
        //     monitor_pay_status: 'NO_PAY',
        //     workName: '出师表',
        //     showCode: '2025Z11L000000002',
        //     dciWorkStatus: 'DCI_PRE_REG_FAIL',
        //     dciUserId: 'DUSANDBOX8250207000000697929',
        //     fileType: 'TEXT'
        //   }
        // ]

        this.total = res.total;
      } else {
        this.$message.error("查询作品列表失败" + res.msg);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    // 删除作品
    workDeleteClick(row) {
      this.$confirm("此操作将永久删除该作品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        console.log(row, "row");
        const res = await workDelete({
          dciWorkId: row.dciWorkId,
        });
        if (res.code == 200) {
          this.$message.success("删除成功");
          this.search();
        } else {
          this.$message.error("删除失败" + res.msg);
        }
      }).catch(() => {});
    },
    // 修改作品
    workUpdateClick(row) {
      this.$router.push({
        path: "/DCIRegistrationDelo",
        query: { dciWorkId: row.dciWorkId },
      });
    },
    workFeedBackClick(row) {
      this.$router.push({
        path: "/DCIFeedBackSubmit",
        query: { dciWorkId: row.dciWorkId },
      });
    },
    workFeedInfoClick(row) {
      this.$router.push({
        path: "/DCIRegistrationDelo",
        query: { dciWorkId: row.dciWorkId, isLook: 1 },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection, "multipleSelection");
    },
    // 申领数字版权证书
    async copyrightCertificate(row) {
      this.$router.push({
        path: "/DigitalCopyrightRegistrationEdit",
        query: { dciWorkId: row.dciWorkId, dciContentId: row.dciContentId },
      });
    },
    // 监测提交
    async monitorFicate(row) {
      this.dialogVisible = true;
      this.dialogVisibleID = row.dciWorkId;
    },
    // 监测支付
    async monitorFicatesdaf(row) {
      if (row.monitorPayStatus == "PAYING") {
        // 支付类型，DCI、DIGITAL_SERVICE、MONITOR、RECORD_SCREEN
        const res = await getPayResult({
          dciWorkId: row.dciWorkId,
          bizType: "MONITOR",
        });
        if (res.code != 200) {
          return;
        }
        console.log(res, "getPayResultgetPayResult");
      }
      this.onMonitorPaymentDialog([row]);
    },
    // 打开监测支付弹窗
    async onMonitorPaymentDialog(rowList = []) {
      if (!(rowList.length > 0)) {
        this.$message.warning("没有可用支付订单");
        return;
      }
      const amount = rowList.reduce((total, row) => {
        return total + toNumber(row.totalAmount);
      }, 0);
      this.$refs.paymentDialog.open({
        amount: amount.toFixed(2),
        rowList,
        onAlipay: this.handleMonitorPaymentAlipay.bind(this),
        onBalance: this.handleMonitorPaymentBalance.bind(this),
      });
    },
    // 监测支付弹窗 - 支付宝支付回调
    async handleMonitorPaymentAlipay(paymentInfo) {
      const { rowList = [] } = paymentInfo || {};
      const row = rowList[0];
      const res = await payMonitor({ dciWorkId: row.dciWorkId, payType: PAY_TYPE.TRANSFER });
      if (res.code == 200) {
        if (res.msg) {
          openPaymentWindow(res.msg);
        } else {
          location.reload();
        }
        this.dialogVisiblePay = true;
      }
    },
    // 监测支付弹窗 - 余额支付回调
    async handleMonitorPaymentBalance(paymentInfo) {
      const { rowList = [] } = paymentInfo || {};
      const row = rowList[0];
      const res = await payMonitor({ dciWorkId: row.dciWorkId, payType: PAY_TYPE.BALANCE });
      if (res.code == 200) {
        this.$message.success("余额支付成功");
        this.search();
      }
    },
    //取证弹窗
    async monitorquFicate(row) {
      const res = await createRecordScreen({
        workId: row.dciWorkId,
      });
    },
    //监测提交
    async dialogVisibleClick() {
      const res = await createMonitorTask({
        keyWord: this.keyWord,
        workId: this.dialogVisibleID,
      });
      if (res.code == 200) {
        this.$message.success("监测成功");
        this.dialogVisible = false;
        this.search();
      } else {
        this.$message.error("提交失败" + res.msg);
      }
    },
    // 监测支付返回
    dialogVisibleClickpay() {
      this.dialogVisiblePay = false;
      this.search();
    },
    formatHours(totalHours) {
      const hoursInDay = 24;
      const days = Math.floor(totalHours / hoursInDay);
      const remainingHours = totalHours % hoursInDay;

      let result = "";

      if (days > 0) {
        result += `${days}天`;
      }

      if (remainingHours > 0) {
        result += `${remainingHours}小时`;
      }

      // 如果总小时数为0，可以选择返回"0小时"或其他默认值
      if (result === "") {
        result = "0小时";
      }

      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
.wenzi {
  height: 80px;
  margin-left: 50px;
  text-align: center;
  line-height: 80px;

  letter-spacing: normal;
  color: #333333;
  text-align: left;
  font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "kern";
  font-kerning: normal;
}
.btn-upd {
  margin-left: 100px;
}
.table-dci {
  width: 1200px;
  margin: 0 auto;
}
.pagination {
  text-align: end;
  margin-top: 20px;
}
.showApp {
  font-family: "Arial Normal", "Arial", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-transform: none;

  // width: 294px;
  display: inline-block;
  padding: 0 5px;
  height: 25px;
  line-height: 25px;
  background: inherit;
  background-color: rgba(242, 242, 242, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(121, 121, 121, 1);
  border-radius: 5px;
  box-shadow: none;
  text-align: left;
  margin: 10px 0;
}
.showName {
  letter-spacing: normal;
  color: #333333;
  line-height: normal;
  text-align: left;
  font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  cursor: pointer;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "kern";
  font-kerning: normal;
}
.showStatus {
  letter-spacing: normal;
  line-height: normal;
  font-size: 18px;
  font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #169bd5;
  text-align: center;
  word-wrap: break-word;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "kern";
  font-kerning: normal;
}
.input-with-select-cc {
  width: 400px;
}
.showStatus-cc {
  letter-spacing: normal;
  line-height: normal;
  font-size: 18px;
  text-align: left;
  font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #6a6a6a;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "kern";
  font-kerning: normal;
  text-align: center;
}
.showStatus-time {
  font-family: "Arial Normal", "Arial", sans-serif;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  line-height: normal;
  font-size: 14px;
  text-align: left;
  color: #797979;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "kern";
  font-kerning: normal;
  text-align: center;
  margin-top: 5px;
}
</style>
